export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path class=\"a\" d=\"M.75 12h22.5M12 .75v22.5\"/></svg>";